import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M18 15V0H0v15h8.4v1.8H4V18h10v-1.2H9.6V15H18zM1.2 13.8V1.2h15.6v12.6H1.2zm7.805-5.508c1.561 0 2.272-1.426 2.272-2.751 0-1.581-.913-2.644-2.272-2.644-1.365 0-2.282 1.062-2.282 2.644 0 1.369.705 2.751 2.282 2.751zm0-4.195c.968 0 1.072 1.01 1.072 1.444 0 .063-.012 1.552-1.072 1.552-1.03 0-1.082-1.293-1.082-1.552 0-.435.105-1.444 1.082-1.444zm3.535 5.786a4.458 4.458 0 0 0-1.843-1.134l-.35-.114-1.342 1.342-1.343-1.343-.35.112a4.44 4.44 0 0 0-1.851 1.136 2.56 2.56 0 0 0-.541.843L4.081 12.8h1.294l.658-1.627a1.38 1.38 0 0 1 .289-.454 3.193 3.193 0 0 1 1.024-.704l1.66 1.659 1.656-1.656c.39.171.731.406 1.018.701.119.122.216.275.289.455l.657 1.626h1.294l-.838-2.074a2.583 2.583 0 0 0-.542-.843z" />
  </svg>
);

export default SvgComponent;
